export var timeRangeData = [
    { key: "1", label: "Last 24 Hours" },
    { key: "2", label: "Last 7 Days" },
    { key: "3", label: "Last 30 Days" },
];
